<template>
  <div>
    <!-- 选择省市区 -->
    <div class="citystbox">
      <div class="cityst">
        <el-popover
          placement="top"
          width="300"
          trigger="hover"
          v-for="(item,index) in dictionaryList"
          :key="index"
        >
          <div class="flex-box">
            <div
              type="text"
              v-for="(items,indexs) in item.options"
              :key="indexs"
              @click="handOptions1(items)"
            >{{items.name}}</div>
          </div>
          <div class="foooterCity" slot="reference">{{item.name}}</div>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>
import * as homes from '@/api/clientshome/index.js';
import * as pmiDictionary from '@/api/pmi/dictionarys';
export default {
  data() {
    return {
      options1: [],
      options2: [],
      options3: [],
      options4: [],
      value0: '',
      value1: '',
      value2: '',
      value3: '',
      dictionaryList: [],
    };
  },
  created() {
    this.getDictionaryList();
  },
  methods: {
    //获取字典list
    getDictionaryList() {
      let para = { NamespaceId: 79 };
      pmiDictionary.PmiDictionaryGetByTypeId(para).then((res) => {
        res.result.forEach((item, index) => {
          item.options = [];
        });
        this.dictionaryList = res.result;
        this.CmsNavigationLoad();
      });
    },
    // 获取院校链接数据
    CmsNavigationLoad() {
      let para = {
        // page: 1,
        // limit: 20,
      };
      homes.CmsNavigationGetList(para).then((res) => {
        this.dictionaryList.forEach((items, indexs) => {
          res.result.forEach((item, index) => {
            if (item.type == items.id) {
              items.options.push(item);
            }
          });
        });
      });
    },
    handOptions1(val) {
      console.log(val.linkurl);
      if (val == '') {
        return;
      }
      {
        window.open(val.linkurl);
        // window.location.href = 'https://www.baidu.com/';
      }
    },
    handOptions2(val) {
      if (val == '') {
        return;
      }
      {
        window.open(val.linkUrl);
      }
    },
    handOptions3(val) {
      if (val == '') {
        return;
      }
      {
        window.open(val.linkUrl);
      }
    },
    handOptions4(val) {
      if (val == '') {
        return;
      }
      {
        window.open(val.linkUrl);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.citystbox {
  padding: 51px 0px 14px 0px;
  background-color: rgb(38, 38, 38);

  .cityst {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    .selectTxt {
      width: 280px;
    }
  }
}


.flex-box {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.foooterCity {
  min-width: 83px;
  font-size: 16px;
  line-height: 26px;
  margin-right: 53px;
  color: #fff;
}
</style>

<style scoped>
/deep/.el-input__inner {
  background-color: rgba(60, 78, 111, 1);
}

/deep/input::-webkit-input-placeholder {
  color: #fff;
  font-size: 16px;
}
/deep/.el-select .el-input .el-select__caret {
  color: #fff;
}
[v-cloak]{
  display: none;
}
</style>